
















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import NnnHeader from '@/components/NnnHeader.vue';
import CardComponent from '@/components/CardComponent.vue';
import TxtCardWidget from '@/components/TxtCardWidget.vue';
import NumCardWidget from '@/components/NumCardWidget.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import { Device } from '../types/corev3';

@Component({
  components: {
    NnnHeader,
    CardComponent,
    TxtCardWidget,
    NumCardWidget,
    TimestampAgo
  },
})
export default class ViewDevice extends Vue {

  showLoading = true;
  error = '';
  lastUpdated = 0;
  device:Device = {} as Device;

  mounted() {
    this.loadData();
  }

  
  async loadData() {

    this.showLoading = true;
    this.error = '';
    this.lastUpdated = 0;

    const validReply = this.$appUtil.readToken(this.$route.query);

    if(validReply.error) {
      this.showLoading = false;
      return this.error = `the URL specified is invalid - please contact nnnco for support`;
    }

    // the URL is valid let's search for a device
    const httpReply = await this.$apiClient.getDevices(validReply.payload!);

    this.showLoading = false;

    if(httpReply.errorMsg)
      return this.error = `unable to retrive information about the specified device - please try again later`;

    if(httpReply.deviceList && httpReply.deviceList.length === 0)
      return this.error = `no devices match the specified token - please contact nnnco for support`;
    
    // we set the device
    this.device = httpReply.deviceList![0];

    this.lastUpdated = new Date().getTime();
  }

  get spFactType():string {
    if(!this.device.deviceId)
      return '';

    const spFact = this.device.network!.loraWan!.spFact;

    if(spFact < 10)
      return 'is-success';
    else if(spFact < 11)
      return 'is-warning';
    else
      return 'is-danger'
  }

  get snrType():string {
    if(!this.device.deviceId)
      return '';

    const snr = this.device.network!.loraWan!.snr;

    if(snr > 0)
      return 'is-success';
    else if(snr > -5)
      return 'is-warning';
    else
      return 'is-danger'
  }

  get rssiType():string {
    if(!this.device.deviceId)
      return '';

    const rssi = this.device.network!.loraWan!.rssi;

    if(rssi > -60)
      return 'is-success';
    else if(rssi > -120)
      return 'is-warning';
    else
      return 'is-danger'
  }
}
